export default __webpack_public_path__ + "static/media/shopping.e8d86349.svg";